import ContainerTruncate from './ContainerTruncate';

export default ContainerTruncate;



// WEBPACK FOOTER //
// ./src/components/atoms/ContainerTruncate/index.js